import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';
import { deleteFiscalYear, getFiscalYear } from '../../network/FiscalYear';
import { ModalAppFiscalYear } from '../../components/upeosoft/ModalApp/ModalApp';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { TbDotsVertical } from 'react-icons/tb';
import { FaCalendarAlt, FaCalendarTimes } from 'react-icons/fa';
import {
  deleteAccountingPeriod,
  getAccountingPeriod,
} from '../../network/accountPeriod';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const AccountPeriod = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getAccountingPeriod],
    queryFn: () => getAccountingPeriod(),
    keepPreviousData: true,
  });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteAccountingPeriod(id),
    onSuccess: (data) => {
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getAccountingPeriod],
      });
    },
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.AccountPeriod,
      icon: <MdModeEditOutline />,
      onClick: () => navigate(`/account-period/edit/${record.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          description={t.areYouSure}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.AccountPeriod}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.name).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.startDate,
      dataIndex: 'start_date',
    },

    {
      title: t.EndDate,
      dataIndex: 'end_date',
    },

    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            {/* <Dropdown
              menu={{ items: items(record) }}
              trigger={['click']}
              // placement="bottomCenter"
            >
              <Button
                size="small"
                type="text"
                icon={<TbDotsVertical size={20} />}
              />
            </Dropdown> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  return (
    <div className="">
      {/* <Heading title={t.settings} subTitle={t.AccountPeriod} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/account-period/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />{' '}
              {t.AddAccountPeriod}
            </Button>
          }
          Placeholder={t.Search}
        />
      </div>
      <ModalAppFiscalYear
        t={t}
        open={open}
        setOpen={setOpen}
        edit={edit}
        record={editId}
      />
    </div>
  );
};

export default AccountPeriod;
